import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FilterListIcon from '@material-ui/icons/FilterList';
import Grid from '@material-ui/core/Grid';
import Loader from 'react-loader-spinner';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import TooltipDismissable from './TooltipDismissable';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import axios from 'axios';
import apiUrl from '../../constants.js';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
  { id: 'nombre', numeric: false, disablePadding: true, label: 'Nombre' },
  { id: 'detalles', numeric: false, disablePadding: false, label: 'Detalles' },
  { id: 'action', numeric: false, disablePadding: false, label: 'Acciones' }
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  spinnerDiv: {
    height: '400px',
    width: '100%',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '150px',
    marginBottom: '150px'
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
    margin: '15px 0px'
  },
}));

export default function CompanyList({companies, loading, tags, setLoading, addTagToCompany, tagId, setTagId}) {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [companyTags, setCompanyTags] = useState([]);
  const [companies2, setCompanies2] = useState(companies);
  const [companyId, setCompanyId] = useState(null);

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  useEffect(() => {
    setCompanies2(companies);
  }, [companies]);

  const handleModal = (action, company) => {

    if(action){
      setCompanyTags(company.company_tags);
      setCompanyId(company.id);
    } else {
      setCompanyTags([]);
      setCompanyId(null);
      setTagId("");
    }

    setOpen(action);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  const handleSubmitTag = (event, tagId, companyId) => {
      event.preventDefault();

      addTagToCompany(companyId, setCompanyTags);
  }

  const removeCompanyTag = (tag) => {

    if(window.confirm("¿Está seguro de desasociar esta etiqueta?")){
      setLoading(true);
      let url = apiUrl+"v1/tags/unattach/"+tag.id+"?id_user="+userId;

      console.log(url);

      axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': token,
          }
        }
      )
      .then(function (response) {
        console.log(response);
        setCompanyTags(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
    }

    console.log(tag.id);

  }

  const filterByName = (event) => {
    const result = companies.filter(company => {
        return company.fantasy_name.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0
    });
    setCompanies2(result);
  }

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, companies2.length - page * rowsPerPage);

  return (
    <Fragment>

    <div>
      <Dialog
        open={open}
        onClose={() => handleModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth = {'md'}
      >
      <form onSubmit={(e) => handleSubmitTag(e, tagId, companyId)}>
        <DialogTitle id="alert-dialog-title">{"Agregar Etiquetas de busqueda"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          { loading ?
            <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
              <Loader
                type="Oval"
                color="#00BFFF"
                height={50}
                width={50}
                className={classes.spinner}
              />
            </Grid>
            :
            <Fragment>
              <div className="row">
                <div className="col-md-6">

                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Alineación del título</InputLabel>
                      <Select
                        label="Alineación del título"
                        name="tagId"
                        required
                        value={tagId}
                        onChange={(e)=>setTagId(e.target.value)}
                      >
                      <MenuItem value={""}>Seleccionar etiqueta</MenuItem>
                      {
                        tags.map((tag, index) => (
                          <MenuItem value={tag.id}>{tag.name}</MenuItem>
                        ))
                      }
                      </Select>
                  </FormControl>

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.margin4Divs}
                  >
                    Agregar
                  </Button>

                </div>
                <div className="col-md-6">
                  {
                    companyTags.length > 0 ?
                      companyTags.map((tag, index) => (
                        <TooltipDismissable
                          key={index}
                          tag={tag}
                          remove={removeCompanyTag}
                        />
                      ))
                    :
                      'No existen etiquetas asociadas'
                  }

                </div>
              </div>
            </Fragment>
          }
          </DialogContentText>
        </DialogContent>
        <DialogActions>

        { loading ?
            null
          :
            <Fragment>
              <Button onClick={() => handleModal(false)} color="primary">
                Cerrar
              </Button>
            </Fragment>
        }
        </DialogActions>
        </form>
      </Dialog>
    </div>


    { loading ?
      <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          className={classes.spinner}
        />
      </Grid>
      :
      <div className={classes.root}>

        <div className="row">
          <div className="col-md-3">
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Buscar por nombre"
              name="title"
              type="text"
              onChange={(e)=>filterByName(e)}
            />
          </div>
        </div>

          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={'medium'}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={companies2.length}
              />
              <TableBody>
                {stableSort(companies2, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((company, index) => {
                    const isItemSelected = isSelected(company.fantasy_name);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={index}
                        selected={isItemSelected}
                      >

                        <TableCell>{company.id}</TableCell>
                        <TableCell component="th" id={labelId} scope="row" padding="none">
                          {company.name} <br/>
                          <strong>URL:</strong> <a href={"https://"+company.subdomain+".max.delivery"} target="_blank">{company.subdomain+".max.delivery"}</a>
                        </TableCell>
                        <TableCell>
                          <strong>Dirección:</strong> {company.company_address!==null ? company.company_address : 'Sin información'}
                        </TableCell>
                        <TableCell>

                         {/*<IconButton
                            aria-label="Eliminar">
                            <DeleteIcon />
                          </IconButton>

                          <IconButton
                            aria-label="Editar">
                            <EditIcon />
                          </IconButton>*/}

                          <IconButton
                            aria-label="Parámetros de busqueda"
                            onClick={() => handleModal(true, company)}>
                            <SearchIcon />
                          </IconButton>

                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: (53) * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, companies2.length>0 ? companies2.length : 50]}
            component="div"
            count={companies2.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
      </div>
    }
    </Fragment>

  );
}

/*import React, { useEffect, useState, Fragment } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Loader from 'react-loader-spinner';

import axios from 'axios';
import apiUrl from '../../constants.js';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  spinnerDiv: {
    height: '400px',
    width: '100%',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '150px',
    marginBottom: '150px'
  },
});

const CompanyList = () => {
  const classes = useStyles();

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let url = apiUrl+"v1/get-companies?id_user="+userId;
    axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setCompanies(response.data);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
    });
  };

    return (
      <Fragment>
      { loading ?
        <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
          <Loader
            type="Oval"
            color="#00BFFF"
            height={50}
            width={50}
            className={classes.spinner}
          />
        </Grid>
        :
        <TableContainer component={Paper}>
           <Table className={classes.table} aria-label="simple table">
             <TableHead>
               <TableRow>
                 <TableCell>Dessert (100g serving)</TableCell>
                 <TableCell align="right">Calories</TableCell>
                 <TableCell align="right">Fat&nbsp;(g)</TableCell>
                 <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                 <TableCell align="right">Protein&nbsp;(g)</TableCell>
               </TableRow>
             </TableHead>
             <TableBody>
               {companies.map((company, index) => (
                 <TableRow key={index}>
                   <TableCell component="th" scope="row">
                     {company.fantasy_name}
                   </TableCell>
                   <TableCell align="right">{company.fantasy_name}</TableCell>
                   <TableCell align="right">{company.fantasy_name}</TableCell>
                   <TableCell align="right">{company.fantasy_name}</TableCell>
                   <TableCell align="right"></TableCell>
                 </TableRow>
               ))}
             </TableBody>
           </Table>
         </TableContainer>
      }
      </Fragment>
    );
};

export default CompanyList;*/
